module.exports = __webpack_public_path__ + "static/img/4.887418a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/zh/4.png
// module id = +RsI
// module chunks = 0